'use client';

export const CURRENT_YEAR = new Date().getFullYear();
